import React from "react";
import { CustomCard } from "../../../../../Components/";
import { OptionalFieldDetails } from "../OptionalFieldDetails";
import { useSelectedTheme } from "../../../../../Hooks";

import useStyles from "../styles";

import { CloseXIcon } from "../../../../../assets/icons";

function ActiveOptionalField({ activeOptionalFields, onCloseHandler }) {
  const styles = useStyles();
  const {
    theme: { palette },
  } = useSelectedTheme();
  const optionalDetailsContent = OptionalFieldDetails();

  return (
    <div>
      {activeOptionalFields.map((activeField) => (
        <CustomCard
          boxShadow="xs"
          borderRadius="xl"
          borderColor="secondary"
          classes={styles.optionalFieldWrapper}
          key={activeField.key}
        >
          <CloseXIcon
            onClick={() => onCloseHandler(activeField.value)}
            className={styles.closeXIcon}
            width="20"
            height="20"
            fill={palette.text.primary}
          />
          {optionalDetailsContent[activeField.value]()}
        </CustomCard>
      ))}
    </div>
  );
}

export default ActiveOptionalField;
